import { createContext, useContext } from 'react';

/** @type {import('react').Context<Element | null>} */
export const IslandRootContext = createContext(null);

/**
 * @param {{
 *   children: import('react').ReactNode,
 *   islandRootElement?: Element | null,
 * }} props
 */
export function IslandRootProvider({ children, islandRootElement = null }) {
	return (
		<IslandRootContext.Provider value={islandRootElement ?? null}>
			{children}
		</IslandRootContext.Provider>
	);
}

/**
 * @returns {Element | null}
 */
export function useIslandRoot() {
	return useContext(IslandRootContext);
}
